import FullScreenReportsModal from "./FullScreenReportsModal";
import ReportsPageContent from "./ReportsPageContent";
import { useReportsLogic } from "./useReportsLogic";

/**
 * ReportsPage
 * Root container for the reports page.
 * Initializes logic via `useReportsLogic` and conditionally renders
 * either a full screen modal or inline layout using `ReportsPageContent`.
 */

export default function ReportsPage({ fullScreen = false, initialFile = null, parentHeight, projectName, toggleFullScreen, }) {
  const logic = useReportsLogic(initialFile, parentHeight, fullScreen);

  const Content = <ReportsPageContent {...logic} fullScreen={fullScreen} toggleFullScreen={toggleFullScreen} />;

  return fullScreen ? (
    <FullScreenReportsModal
      open={true}
      onClose={toggleFullScreen}
      projectName={projectName?.name ?? ""}
    >
      {Content}
    </FullScreenReportsModal>
  ) : Content;
}